import { render, staticRenderFns } from "./TijianInfo.vue?vue&type=template&id=6dea8a1f&scoped=true"
import script from "./TijianInfo.vue?vue&type=script&lang=js"
export * from "./TijianInfo.vue?vue&type=script&lang=js"
import style0 from "./TijianInfo.vue?vue&type=style&index=0&id=6dea8a1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dea8a1f",
  null
  
)

export default component.exports